/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectScopingPageRefetchQueryVariables = {
    projectId?: string | null | undefined;
    noStaleTasks?: boolean | null | undefined;
    fetchLazyData: boolean;
    fetchCustomFields: boolean;
    personId: string;
};
export type ProjectScopingPageRefetchQueryResponse = {
    readonly viewer: {
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"ProjectScopingPage_viewer">;
    } | null;
};
export type ProjectScopingPageRefetchQuery = {
    readonly response: ProjectScopingPageRefetchQueryResponse;
    readonly variables: ProjectScopingPageRefetchQueryVariables;
};



/*
query ProjectScopingPageRefetchQuery(
  $projectId: String
  $noStaleTasks: Boolean
  $fetchLazyData: Boolean!
  $fetchCustomFields: Boolean!
  $personId: ID!
) {
  viewer {
    component(name: "new_scoping_refetch")
    ...ProjectScopingPage_viewer_1hnnKn
    id
  }
}

fragment LabelDropdownJS_labels on Label {
  color
  name
  id
  category {
    id
    name
  }
}

fragment ProjectHeader_project on ProjectType {
  id
  companyProjectId
  ...ProjectIndicatorJS_project
  name
  projectColor
  isInProjectGroup
  projectGroupCompanyId
  projectGroupName
  projectGroupColor
  useBaseline
  budgetType
  sprintTimeBox
}

fragment ProjectHeader_psProject on ProjectServiceProjectType {
  name
  psProgram {
    id
    name
    color
    prefix
    isViewerProgramMember
  }
}

fragment ProjectIndicatorJS_project on ProjectType {
  name
  companyProjectId
  customProjectId
  projectColor
}

fragment ProjectScopingPage_viewer_1hnnKn on Viewer {
  id
  language
  email
  firstName
  lastName
  timerStartDate
  actualPersonId
  harvestUser
  unit4User
  excludeFromCompanyLockedPeriod
  submitLockedDateYear
  submitLockedDateMonth
  submitLockedDateDay
  startDate
  endDate
  createdAt
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  sunday
  availableFeatureFlags {
    key
    id
  }
  timerTask {
    id
  }
  company {
    ...genericTaskContextMenu_company
    jiraCloudEnabled
    jiraServerEnabled
    integrations {
      jiraCloud {
        syncSettings {
          isJiraToForecastOneWaySync
        }
        id
      }
      jiraServer {
        syncSettings {
          isJiraToForecastOneWaySync
        }
        id
      }
      id
    }
    modules {
      moduleType
      id
    }
    person(id: $personId) {
      id
      role {
        id
        name
      }
    }
    isUsingProjectAllocation
    isUsingMixedAllocation
    holidayCalendars(first: 10000) {
      edges {
        node {
          id
          holidayCalendarEntries(first: 100000) {
            edges {
              node {
                id
                name
                year
                month
                day
                __typename
              }
              cursor
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    allPersons(first: 1000000, onlyActive: true) {
      edges {
        node {
          id
          firstName
          lastName
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    id
    currency
    harvestEnabled
    unit4Enabled
    lockedPeriodYear
    lockedPeriodMonth
    lockedPeriodDay
    labels(first: 1000000, labelType: TASK) {
      edges {
        node {
          id
          name
          color
          category {
            id
            name
          }
          ...LabelDropdownJS_labels
        }
      }
    }
    roles(first: 1000000) {
      edges {
        ...RoleDropdown_roles
        node {
          id
          name
        }
      }
    }
    teams(first: 1000000) {
      edges {
        node {
          id
          name
          teamPersons(first: 1000) {
            edges {
              node {
                id
                person {
                  id
                }
              }
            }
          }
        }
      }
    }
    customFieldDefinitionsV2(first: 1000) @include(if: $fetchCustomFields) {
      edges {
        node {
          id
          key
          displayName
          entityType
          ... on TextCustomField {
            readOnly
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  filters(first: 1000000, projectId: $projectId, filterSection: SCOPING) {
    edges {
      node {
        id
        name
        section
        value
        updatedAt
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  projects(first: 1000000, excludeRestricted: true) {
    edges {
      node {
        id
        companyProjectId
        customProjectId
        name
        status
        isInProjectGroup
        projectColor
      }
    }
  }
  project(id: $projectId) {
    ...ProjectHeader_project
    ...SecondaryNavigation_project
    projectFirstDateYear
    projectFirstDateMonth
    projectFirstDateDay
    projectLastDateYear
    projectLastDateMonth
    projectLastDateDay
    baselineTargetPrice
    baselineTargetMinutes
    id
    isNoStaleTasksAllowed
    name
    demo
    budgetWork
    budgetType
    defaultPeriodBudgetType
    budget
    billable
    synchBaselineAndScopingDates
    program {
      name
      prefix
      budgetType
      members {
        edges {
          node {
            role
            person {
              id
            }
            id
          }
        }
      }
      id
    }
    sprintTimeBox
    isInProjectGroup
    useBaseline
    projectGroupId
    status
    companyProjectId
    customProjectId
    estimationUnit
    minutesPerEstimationPoint
    timeRegistrations(first: 10000000, onlyProjectRegistrations: true) @include(if: $fetchLazyData) {
      edges {
        node {
          id
          minutesRegistered
          billableMinutesRegistered
          invoiced
          price
          updatedAt
          year
          month
          day
          retainerConflictHandled
          task {
            id
          }
          person {
            id
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    retainerPeriods(first: 100000) {
      edges {
        node {
          id
          name
          startYear
          startMonth
          startDay
          endYear
          endMonth
          endDay
          available
          periodLength
          periodPeriodicity
          periodPriceAmount
          periodHoursAmount
          periodBudgetType
          periodSettingIgnoreForBilling
          periodSettingSubtractValue
          periodSettingRollValue
          periodSettingAddExpenses
          periodDifferencePriceAmount
          periodDifferenceHoursAmount
          sharedPeriodDifferenceHoursAmount
          sharedPeriodDifferencePriceAmount
          ignoredRolloverHours
          ignoredRolloverPrice
          periodLocked
          periodLockedTime
        }
      }
    }
    projectColor
    projectStartYear
    projectStartMonth
    projectStartDay
    projectEndYear
    projectEndMonth
    projectEndDay
    useManualAllocations
    remainingAutoCalculated
    isJiraProject
    useTaskOwner
    useTaskFollowers
    taskLevels
    useTaskHierarchy
    vstsProject
    vstsAccount
    harvestProjectId
    vstsTwoWaySync
    jiraSubtaskType
    progress
    manualProgressOnProjectEnabled
    manualProgressOnPhasesEnabled
    manualProgressOnTasksEnabled
    financialSourceSettings {
      plannedHours
      plannedRevenue
      plannedCost
      actualRevenue
      actualCost
      forecastRevenue
      id
    }
    jiraCloudProject {
      id
    }
    jiraCloudEpicIds
    jiraServerProject {
      id
    }
    sageProject {
      sageProjectId
      id
    }
    statusColumnsV2(first: 1000000) {
      edges {
        node {
          id
          name
          order
          jiraStatusId
          category
        }
      }
    }
    rateCard {
      id
      currency
      rates(first: 10000) {
        edges {
          node {
            id
            rate
            defaultRate
            startDate
            role {
              id
            }
          }
        }
      }
      disabledRoles {
        id
      }
    }
    projectPersons(first: 1000000) {
      edges {
        node {
          id
          role {
            id
            name
          }
          person {
            id
            firstName
            lastName
            fullName
            initials
            profilePictureId
            profilePictureDefaultId
            active
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
            holidayCalendar {
              id
            }
            role {
              id
              name
            }
            client {
              id
            }
            allocations(first: 1000000, idleTimeOnly: true) {
              edges {
                node {
                  id
                  monday
                  tuesday
                  wednesday
                  thursday
                  friday
                  saturday
                  sunday
                  startYear
                  startMonth
                  startDay
                  endYear
                  endMonth
                  endDay
                  idleTime {
                    isInternalTime
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
    phases(first: 1000000) {
      edges {
        node {
          baselineTargetPrice
          baselineTargetMinutes
          baselineCost
          inheritDatesFrom
          progress
          progressDetails {
            progress
            id
          }
          phaseBaselineRoles {
            edges {
              node {
                role {
                  id
                }
                baselineMinutes
                baselinePrice
                id
              }
            }
          }
          id
          name
          startYear
          startMonth
          startDay
          startFrom
          deadlineDay
          deadlineMonth
          deadlineYear
          deadlineFrom
          baselineStartYear
          baselineStartMonth
          baselineStartDay
          baselineDeadlineDay
          baselineDeadlineMonth
          baselineDeadlineYear
          unit4Id
          jiraId
          phasePersons(first: 10000) {
            edges {
              node {
                id
                availableMinutes
                scheduledMinutes
                person {
                  id
                }
              }
            }
          }
          customFields @include(if: $fetchCustomFields) {
            edges {
              node {
                __typename
                key
                displayName
                value
                type
                ... on TextCustomFieldValue {
                  readOnly
                }
                ... on DropdownCustomFieldValue {
                  options {
                    id
                    displayName
                  }
                }
                id
              }
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    baselineFinancialNumbers: groupedFinancialNumbers(convertToProjectCurrency: true, groupBy: ["PHASE_BASELINE_ROLE", "PHASE"]) {
      baselineRevenue
      baselineTimeAndExpenses
      baselineCost
      baselineProfit
      baselineMargin
      baselineRatePerHour
      baselineCostPerHour
      baselineMinutes
      phaseBaselineRoleId
      phaseBaselineExpenseId
      phaseId
    }
    sprints(first: 1000000) {
      edges {
        node {
          id
          name
          endYear
          endMonth
          endDay
          startYear
          startMonth
          startDay
        }
      }
    }
    tasks(first: 100000, simpleResponse: true, noStaleTasks: $noStaleTasks) {
      edges {
        node {
          id
          readOnly {
            isReadOnly
            id
          }
          userCanDeleteTask
          userCantDeleteTaskReason
          hasInvoicedTime
          hasLockedTime
          hasTimeRegistrations
          approved
          name
          description
          sortOrder
          done
          billable
          blocked
          progress @include(if: $fetchLazyData)
  currentPrice @include(if: $fetchLazyData)
  actualCost @include(if: $fetchLazyData)
  plannedCost @include(if: $fetchLazyData)
  timeLeft @include(if: $fetchLazyData)
  timeRegistrations(first: 10000) @include(if: $fetchLazyData) {
            edges {
              node {
                id
                minutesRegistered
                billableMinutesRegistered
                price
                invoiced
                year
                month
                day
                retainerConflictHandled
                person {
                  id
                  role {
                    id
                  }
                }
                __typename
              }
              cursor
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          bug
          latestUiUpdateAt
          startFrom
          deadlineFrom
          startYear
          startMonth
          startDay
          deadlineDay
          deadlineMonth
          deadlineYear
          estimateForecast
          estimateForecastMinutes
          estimateForecastPrice
          totalPriceAtCompletion
          totalCostAtCompletion
          allTotalTimeAndExpensesAtCompletion
          companyTaskId
          canStart
          canBeSetToDone
          highPriority
          hasDependency
          jiraId
          vstsId
          isUnit4Task
          subTaskCount
          parentTaskId
          hasChildren
          sageIntacctId
          favoured
          progressDetails {
            progress
            id
          }
          owner {
            id
            permissions
          }
          followers {
            id
            permissions
          }
          phase {
            id
            name
            startYear
            startMonth
            startDay
            startFrom
            deadlineDay
            deadlineMonth
            deadlineYear
            deadlineFrom
          }
          role {
            id
            name
          }
          sprint {
            id
            name
            startYear
            startMonth
            startDay
            endYear
            endMonth
            endDay
          }
          statusColumnV2 {
            id
            name
            category
          }
          project {
            id
            demo
            billable
            estimationUnit
            minutesPerEstimationPoint
            projectStartYear
            projectStartMonth
            projectStartDay
            projectEndYear
            projectEndMonth
            projectEndDay
            budgetType
            projectPerson(personId: $personId) {
              role {
                id
                name
              }
              id
            }
            program {
              name
              prefix
              budgetType
              members {
                edges {
                  node {
                    role
                    person {
                      id
                    }
                    id
                  }
                }
              }
              id
            }
            name
            status
            isJiraProject
            vstsProject
            vstsAccount
            vstsTwoWaySync
            projectColor
            companyProjectId
            customProjectId
            harvestProject {
              id
            }
            unit4Project {
              id
              activitiesEnabled
            }
            sprintTimeBox
          }
          taskLabels {
            id
            label {
              id
              name
              color
            }
          }
          taskDismissedNotifications {
            taskOverrunPredictionDismissed
            id
          }
          assignedPersons {
            id
            firstName
            lastName
            fullName
            active
            email
            profilePictureId
            profilePictureDefaultId
            permissions
          }
          thisTaskDependsOn(first: 1000) {
            edges {
              node {
                id
                type
                thisDependsOnTask {
                  id
                  name
                  deadlineYear
                  deadlineMonth
                  deadlineDay
                  startYear
                  startMonth
                  startDay
                }
              }
            }
          }
          customFields @include(if: $fetchCustomFields) {
            edges {
              node {
                __typename
                key
                displayName
                value
                type
                ... on TextCustomFieldValue {
                  readOnly
                }
                ... on DropdownCustomFieldValue {
                  options {
                    id
                    displayName
                  }
                }
                id
              }
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    allocations(first: 100000) {
      edges {
        node {
          id
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
          sunday
          startYear
          startMonth
          startDay
          endYear
          endMonth
          endDay
          person {
            id
            role {
              id
            }
            holidayCalendar {
              id
            }
          }
          project {
            id
          }
          isSoft
        }
      }
    }
    expenseFinancialNumbers: financialNumbers(searchQuery: {filters: [{field: ROLE, operator: IS, value: "Um9sZTotMQ=="}]}, convertToProjectCurrency: true) {
      allTotalTimeAndExpensesAtCompletion
    }
    totalFinancialNumbers: financialNumbers(convertToProjectCurrency: true) {
      totalCostAtCompletion
      totalRevenueRecognition
      totalRevenueProfitAtCompletion
      totalRevenueMarginAtCompletion
      forecastMinutes
      registeredMinutes
      billableActualMinutes
      nonBillableActualMinutes
      billableTotalTimeAndExpensesAtCompletion
      baselineMinutes
      allocationMinutes
      scopeApprovedMinutes
      remainingMinutes
      baselineRevenue
      plannedCost
      actualCost
      projectedBillableMinutes
      projectedNonBillableMinutes
      projectedTotalMinutes
      plannedRevenue
      plannedProfit
      plannedMargin
      baselineMargin
      remainingCost
      actualRevenue
      baselineCost
      baselineProfit
    }
  }
  psProject(companyProjectId: $projectId) {
    ...ProjectHeader_psProject
    id
  }
}

fragment RoleDropdown_roles on RoleTypeEdge {
  node {
    name
    id
  }
}

fragment SecondaryNavigation_project on ProjectType {
  companyProjectId
  customProjectId
  sprintTimeBox
  budgetType
  projectGroupId
  useBaseline
  hasInvoices
  financialSourceSettings {
    plannedCost
    plannedRevenue
    actualCost
    actualRevenue
    forecastCost
    forecastRevenue
    id
  }
}

fragment genericTaskContextMenu_company on Company {
  id
  jiraCloudEnabled
  jiraServerEnabled
  integrations {
    jiraCloud {
      syncSettings {
        isJiraToForecastOneWaySync
      }
      id
    }
    jiraServer {
      syncSettings {
        isJiraToForecastOneWaySync
      }
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noStaleTasks",
    "type": "Boolean"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchLazyData",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchCustomFields",
    "type": "Boolean!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "personId",
    "type": "ID!"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "new_scoping_refetch"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"new_scoping_refetch\")"
},
v2 = {
  "kind": "Variable",
  "name": "noStaleTasks",
  "variableName": "noStaleTasks"
},
v3 = {
  "kind": "Variable",
  "name": "personId",
  "variableName": "personId"
},
v4 = {
  "kind": "Variable",
  "name": "projectId",
  "variableName": "projectId"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monday",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tuesday",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wednesday",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thursday",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "friday",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "saturday",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sunday",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v18 = [
  (v5/*: any*/)
],
v19 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "JiraSyncSettingsType",
    "kind": "LinkedField",
    "name": "syncSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isJiraToForecastOneWaySync",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v5/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = [
  (v5/*: any*/),
  (v20/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v24 = {
  "kind": "Literal",
  "name": "first",
  "value": 100000
},
v25 = [
  (v24/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v33 = [
  (v32/*: any*/),
  {
    "kind": "Literal",
    "name": "onlyActive",
    "value": true
  }
],
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v36 = [
  (v32/*: any*/)
],
v37 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v40 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "readOnly",
    "storageKey": null
  }
],
v41 = [
  {
    "kind": "Literal",
    "name": "filterSection",
    "value": "SCOPING"
  },
  (v32/*: any*/),
  (v4/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInProjectGroup",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintTimeBox",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedCost",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedRevenue",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualCost",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualRevenue",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTargetPrice",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTargetMinutes",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "demo",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prefix",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "ProgramType",
  "kind": "LinkedField",
  "name": "program",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v59/*: any*/),
    (v49/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectServiceProgramMemberTypeConnection",
      "kind": "LinkedField",
      "name": "members",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectServiceProgramMemberTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectServiceProgramMemberType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "role",
                  "storageKey": null
                },
                (v38/*: any*/),
                (v5/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesPerEstimationPoint",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJiraProject",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsProject",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsAccount",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsTwoWaySync",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "concreteType": "HolidayCalendar",
  "kind": "LinkedField",
  "name": "holidayCalendar",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineCost",
  "storageKey": null
},
v88 = [
  (v79/*: any*/),
  (v5/*: any*/)
],
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineMinutes",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineFrom",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraId",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v97 = {
  "condition": "fetchCustomFields",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomFieldValueV2TypeConnection",
      "kind": "LinkedField",
      "name": "customFields",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomFieldValueV2TypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v29/*: any*/),
                (v17/*: any*/),
                (v39/*: any*/),
                (v42/*: any*/),
                (v96/*: any*/),
                (v5/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v40/*: any*/),
                  "type": "TextCustomFieldValue"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomFieldDropdownOption",
                      "kind": "LinkedField",
                      "name": "options",
                      "plural": true,
                      "selections": [
                        (v5/*: any*/),
                        (v39/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "DropdownCustomFieldValue"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v98 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineRevenue",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineProfit",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineMargin",
  "storageKey": null
},
v102 = [
  (v24/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "simpleResponse",
    "value": true
  }
],
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCostAtCompletion",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allTotalTimeAndExpensesAtCompletion",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v106 = [
  (v5/*: any*/),
  (v105/*: any*/)
],
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesRegistered",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableMinutesRegistered",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiced",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "retainerConflictHandled",
  "storageKey": null
},
v112 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000000
  },
  {
    "kind": "Literal",
    "name": "onlyProjectRegistrations",
    "value": true
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectScopingPageRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "fetchCustomFields",
                "variableName": "fetchCustomFields"
              },
              {
                "kind": "Variable",
                "name": "fetchLazyData",
                "variableName": "fetchLazyData"
              },
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectScopingPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectScopingPageRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timerStartDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualPersonId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "harvestUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unit4User",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "excludeFromCompanyLockedPeriod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateDay",
            "storageKey": null
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "timerTask",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraCloudEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraServerEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyIntegrationsType",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyJiraSettingsType",
                    "kind": "LinkedField",
                    "name": "jiraCloud",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyJiraSettingsType",
                    "kind": "LinkedField",
                    "name": "jiraServer",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "personId"
                  }
                ],
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsingProjectAllocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsingMixedAllocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "HolidayCalendarTypeConnection",
                "kind": "LinkedField",
                "name": "holidayCalendars",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HolidayCalendarTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HolidayCalendar",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": (v25/*: any*/),
                            "concreteType": "HolidayCalendarEntryTypeConnection",
                            "kind": "LinkedField",
                            "name": "holidayCalendarEntries",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HolidayCalendarEntryTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "HolidayCalendarEntry",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v20/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v30/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v31/*: any*/)
                            ],
                            "storageKey": "holidayCalendarEntries(first:100000)"
                          },
                          {
                            "alias": null,
                            "args": (v25/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "HolidayCalendar_holidayCalendarEntries",
                            "kind": "LinkedHandle",
                            "name": "holidayCalendarEntries"
                          },
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v30/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v31/*: any*/)
                ],
                "storageKey": "holidayCalendars(first:10000)"
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Company_holidayCalendars",
                "kind": "LinkedHandle",
                "name": "holidayCalendars"
              },
              {
                "alias": null,
                "args": (v33/*: any*/),
                "concreteType": "PersonTypeConnection",
                "kind": "LinkedField",
                "name": "allPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v30/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v31/*: any*/)
                ],
                "storageKey": "allPersons(first:1000000,onlyActive:true)"
              },
              {
                "alias": null,
                "args": (v33/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Company_allPersons",
                "kind": "LinkedHandle",
                "name": "allPersons"
              },
              (v34/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unit4Enabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v32/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "labelType",
                    "value": "TASK"
                  }
                ],
                "concreteType": "LabelTypeConnection",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v20/*: any*/),
                          (v35/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LabelCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": (v21/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "labels(first:1000000,labelType:\"TASK\")"
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": "RoleTypeConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "roles(first:1000000)"
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": "TeamTypeConnection",
                "kind": "LinkedField",
                "name": "teams",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": (v37/*: any*/),
                            "concreteType": "TeamPersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "teamPersons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamPersonTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamPerson",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v38/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "teamPersons(first:1000)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "teams(first:1000000)"
              },
              {
                "condition": "fetchCustomFields",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v37/*: any*/),
                    "concreteType": "CustomFieldDefinitionV2TypeConnection",
                    "kind": "LinkedField",
                    "name": "customFieldDefinitionsV2",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomFieldDefinitionV2TypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v17/*: any*/),
                              (v39/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "entityType",
                                "storageKey": null
                              },
                              (v29/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v40/*: any*/),
                                "type": "TextCustomField"
                              }
                            ],
                            "storageKey": null
                          },
                          (v30/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v31/*: any*/)
                    ],
                    "storageKey": "customFieldDefinitionsV2(first:1000)"
                  },
                  {
                    "alias": null,
                    "args": (v37/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Company_customFieldDefinitionsV2",
                    "kind": "LinkedHandle",
                    "name": "customFieldDefinitionsV2"
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v41/*: any*/),
            "concreteType": "FilterTypeConnection",
            "kind": "LinkedField",
            "name": "filters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FilterTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Filter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "section",
                        "storageKey": null
                      },
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v30/*: any*/)
                ],
                "storageKey": null
              },
              (v31/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v41/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_filters",
            "kind": "LinkedHandle",
            "name": "filters"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "excludeRestricted",
                "value": true
              },
              (v32/*: any*/)
            ],
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v20/*: any*/),
                      (v46/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "projects(excludeRestricted:true,first:1000000)"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v44/*: any*/),
              (v20/*: any*/),
              (v45/*: any*/),
              (v48/*: any*/),
              (v47/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupCompanyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useBaseline",
                "storageKey": null
              },
              (v49/*: any*/),
              (v50/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasInvoices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinancialSourceSettings",
                "kind": "LinkedField",
                "name": "financialSourceSettings",
                "plural": false,
                "selections": [
                  (v51/*: any*/),
                  (v52/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastRevenue",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedHours",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateDay",
                "storageKey": null
              },
              (v55/*: any*/),
              (v56/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isNoStaleTasksAllowed",
                "storageKey": null
              },
              (v57/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetWork",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodBudgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budget",
                "storageKey": null
              },
              (v58/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "synchBaselineAndScopingDates",
                "storageKey": null
              },
              (v60/*: any*/),
              (v46/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              {
                "alias": null,
                "args": (v25/*: any*/),
                "concreteType": "RetainerPeriodTypeConnection",
                "kind": "LinkedField",
                "name": "retainerPeriods",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetainerPeriodTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetainerPeriodType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v20/*: any*/),
                          (v63/*: any*/),
                          (v64/*: any*/),
                          (v65/*: any*/),
                          (v66/*: any*/),
                          (v67/*: any*/),
                          (v68/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "available",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodLength",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodPeriodicity",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodPriceAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodHoursAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodBudgetType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodSettingIgnoreForBilling",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodSettingSubtractValue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodSettingRollValue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodSettingAddExpenses",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodDifferencePriceAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodDifferenceHoursAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sharedPeriodDifferenceHoursAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sharedPeriodDifferencePriceAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ignoredRolloverHours",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ignoredRolloverPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodLocked",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodLockedTime",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "retainerPeriods(first:100000)"
              },
              (v69/*: any*/),
              (v70/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useManualAllocations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remainingAutoCalculated",
                "storageKey": null
              },
              (v75/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskOwner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskFollowers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskLevels",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskHierarchy",
                "storageKey": null
              },
              (v76/*: any*/),
              (v77/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestProjectId",
                "storageKey": null
              },
              (v78/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraSubtaskType",
                "storageKey": null
              },
              (v79/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnProjectEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnPhasesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnTasksEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectType",
                "kind": "LinkedField",
                "name": "jiraCloudProject",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraCloudEpicIds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraServerProjectType",
                "kind": "LinkedField",
                "name": "jiraServerProject",
                "plural": false,
                "selections": (v18/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SageProjectType",
                "kind": "LinkedField",
                "name": "sageProject",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sageProjectId",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": "StatusColumnV2TypeConnection",
                "kind": "LinkedField",
                "name": "statusColumnsV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnV2TypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatusColumnV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "order",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jiraStatusId",
                            "storageKey": null
                          },
                          (v80/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "statusColumnsV2(first:1000000)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v34/*: any*/),
                  {
                    "alias": null,
                    "args": (v23/*: any*/),
                    "concreteType": "RateTypeConnection",
                    "kind": "LinkedField",
                    "name": "rates",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RateTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Rate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "defaultRate",
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              (v81/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "rates(first:10000)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "disabledRoles",
                    "plural": true,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": "ProjectPersonTypeConnection",
                "kind": "LinkedField",
                "name": "projectPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectPersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectPerson",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v82/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "initials",
                                "storageKey": null
                              },
                              (v83/*: any*/),
                              (v84/*: any*/),
                              (v85/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v86/*: any*/),
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Client",
                                "kind": "LinkedField",
                                "name": "client",
                                "plural": false,
                                "selections": (v18/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  (v32/*: any*/),
                                  {
                                    "kind": "Literal",
                                    "name": "idleTimeOnly",
                                    "value": true
                                  }
                                ],
                                "concreteType": "AllocationTypeConnection",
                                "kind": "LinkedField",
                                "name": "allocations",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AllocationTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Allocation",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v10/*: any*/),
                                          (v11/*: any*/),
                                          (v12/*: any*/),
                                          (v13/*: any*/),
                                          (v14/*: any*/),
                                          (v15/*: any*/),
                                          (v16/*: any*/),
                                          (v63/*: any*/),
                                          (v64/*: any*/),
                                          (v65/*: any*/),
                                          (v66/*: any*/),
                                          (v67/*: any*/),
                                          (v68/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "IdleTime",
                                            "kind": "LinkedField",
                                            "name": "idleTime",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isInternalTime",
                                                "storageKey": null
                                              },
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "allocations(first:1000000,idleTimeOnly:true)"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projectPersons(first:1000000)"
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": "PhaseTypeConnection",
                "kind": "LinkedField",
                "name": "phases",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhaseType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v55/*: any*/),
                          (v56/*: any*/),
                          (v87/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inheritDatesFrom",
                            "storageKey": null
                          },
                          (v79/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseProgress",
                            "kind": "LinkedField",
                            "name": "progressDetails",
                            "plural": false,
                            "selections": (v88/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseBaselineRoleTypeConnection",
                            "kind": "LinkedField",
                            "name": "phaseBaselineRoles",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PhaseBaselineRoleTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PhaseBaselineRoleType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v81/*: any*/),
                                      (v89/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "baselinePrice",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v20/*: any*/),
                          (v63/*: any*/),
                          (v64/*: any*/),
                          (v65/*: any*/),
                          (v90/*: any*/),
                          (v91/*: any*/),
                          (v92/*: any*/),
                          (v93/*: any*/),
                          (v94/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unit4Id",
                            "storageKey": null
                          },
                          (v95/*: any*/),
                          {
                            "alias": null,
                            "args": (v23/*: any*/),
                            "concreteType": "PhasePersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "phasePersons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PhasePersonTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PhasePerson",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "availableMinutes",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "scheduledMinutes",
                                        "storageKey": null
                                      },
                                      (v38/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "phasePersons(first:10000)"
                          },
                          (v29/*: any*/),
                          (v97/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v30/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v31/*: any*/)
                ],
                "storageKey": "phases(first:1000000)"
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Project_phases",
                "kind": "LinkedHandle",
                "name": "phases"
              },
              {
                "alias": "baselineFinancialNumbers",
                "args": [
                  (v98/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "groupBy",
                    "value": [
                      "PHASE_BASELINE_ROLE",
                      "PHASE"
                    ]
                  }
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "groupedFinancialNumbers",
                "plural": true,
                "selections": [
                  (v99/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineTimeAndExpenses",
                    "storageKey": null
                  },
                  (v87/*: any*/),
                  (v100/*: any*/),
                  (v101/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineRatePerHour",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineCostPerHour",
                    "storageKey": null
                  },
                  (v89/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phaseBaselineRoleId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phaseBaselineExpenseId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phaseId",
                    "storageKey": null
                  }
                ],
                "storageKey": "groupedFinancialNumbers(convertToProjectCurrency:true,groupBy:[\"PHASE_BASELINE_ROLE\",\"PHASE\"])"
              },
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": "SprintTypeConnection",
                "kind": "LinkedField",
                "name": "sprints",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SprintTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Sprint",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v20/*: any*/),
                          (v66/*: any*/),
                          (v67/*: any*/),
                          (v68/*: any*/),
                          (v63/*: any*/),
                          (v64/*: any*/),
                          (v65/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "sprints(first:1000000)"
              },
              {
                "alias": null,
                "args": (v102/*: any*/),
                "concreteType": "TaskTypeConnection",
                "kind": "LinkedField",
                "name": "tasks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Task",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskReadOnly",
                            "kind": "LinkedField",
                            "name": "readOnly",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isReadOnly",
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "userCanDeleteTask",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "userCantDeleteTaskReason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasInvoicedTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasLockedTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasTimeRegistrations",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "approved",
                            "storageKey": null
                          },
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sortOrder",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "done",
                            "storageKey": null
                          },
                          (v58/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "blocked",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bug",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "latestUiUpdateAt",
                            "storageKey": null
                          },
                          (v90/*: any*/),
                          (v94/*: any*/),
                          (v63/*: any*/),
                          (v64/*: any*/),
                          (v65/*: any*/),
                          (v91/*: any*/),
                          (v92/*: any*/),
                          (v93/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "estimateForecast",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "estimateForecastMinutes",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "estimateForecastPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalPriceAtCompletion",
                            "storageKey": null
                          },
                          (v103/*: any*/),
                          (v104/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "companyTaskId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canStart",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canBeSetToDone",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "highPriority",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasDependency",
                            "storageKey": null
                          },
                          (v95/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "vstsId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUnit4Task",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subTaskCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parentTaskId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasChildren",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sageIntacctId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "favoured",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskProgress",
                            "kind": "LinkedField",
                            "name": "progressDetails",
                            "plural": false,
                            "selections": (v88/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": (v106/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "followers",
                            "plural": true,
                            "selections": (v106/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseType",
                            "kind": "LinkedField",
                            "name": "phase",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v20/*: any*/),
                              (v63/*: any*/),
                              (v64/*: any*/),
                              (v65/*: any*/),
                              (v90/*: any*/),
                              (v91/*: any*/),
                              (v92/*: any*/),
                              (v93/*: any*/),
                              (v94/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v20/*: any*/),
                              (v63/*: any*/),
                              (v64/*: any*/),
                              (v65/*: any*/),
                              (v66/*: any*/),
                              (v67/*: any*/),
                              (v68/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StatusColumnV2",
                            "kind": "LinkedField",
                            "name": "statusColumnV2",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v20/*: any*/),
                              (v80/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectType",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v57/*: any*/),
                              (v58/*: any*/),
                              (v61/*: any*/),
                              (v62/*: any*/),
                              (v69/*: any*/),
                              (v70/*: any*/),
                              (v71/*: any*/),
                              (v72/*: any*/),
                              (v73/*: any*/),
                              (v74/*: any*/),
                              (v49/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  (v3/*: any*/)
                                ],
                                "concreteType": "ProjectPerson",
                                "kind": "LinkedField",
                                "name": "projectPerson",
                                "plural": false,
                                "selections": [
                                  (v22/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v60/*: any*/),
                              (v20/*: any*/),
                              (v46/*: any*/),
                              (v75/*: any*/),
                              (v76/*: any*/),
                              (v77/*: any*/),
                              (v78/*: any*/),
                              (v48/*: any*/),
                              (v44/*: any*/),
                              (v45/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HarvestProjectType",
                                "kind": "LinkedField",
                                "name": "harvestProject",
                                "plural": false,
                                "selections": (v18/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Unit4ProjectType",
                                "kind": "LinkedField",
                                "name": "unit4Project",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "activitiesEnabled",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v50/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskLabel",
                            "kind": "LinkedField",
                            "name": "taskLabels",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Label",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v20/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskDismissedNotifications",
                            "kind": "LinkedField",
                            "name": "taskDismissedNotifications",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "taskOverrunPredictionDismissed",
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "assignedPersons",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v82/*: any*/),
                              (v85/*: any*/),
                              (v6/*: any*/),
                              (v83/*: any*/),
                              (v84/*: any*/),
                              (v105/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v37/*: any*/),
                            "concreteType": "DependencyTypeConnection",
                            "kind": "LinkedField",
                            "name": "thisTaskDependsOn",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DependencyTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "DependencyType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v96/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Task",
                                        "kind": "LinkedField",
                                        "name": "thisDependsOnTask",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v20/*: any*/),
                                          (v93/*: any*/),
                                          (v92/*: any*/),
                                          (v91/*: any*/),
                                          (v63/*: any*/),
                                          (v64/*: any*/),
                                          (v65/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "thisTaskDependsOn(first:1000)"
                          },
                          (v29/*: any*/),
                          {
                            "condition": "fetchLazyData",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v79/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "currentPrice",
                                "storageKey": null
                              },
                              (v53/*: any*/),
                              (v51/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "timeLeft",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v23/*: any*/),
                                "concreteType": "TimeRegTypeConnection",
                                "kind": "LinkedField",
                                "name": "timeRegistrations",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TimeRegTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TimeRegType",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v107/*: any*/),
                                          (v108/*: any*/),
                                          (v109/*: any*/),
                                          (v110/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v28/*: any*/),
                                          (v111/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Person",
                                            "kind": "LinkedField",
                                            "name": "person",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v81/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v29/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v30/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v31/*: any*/)
                                ],
                                "storageKey": "timeRegistrations(first:10000)"
                              },
                              {
                                "alias": null,
                                "args": (v23/*: any*/),
                                "filters": [],
                                "handle": "connection",
                                "key": "Task_timeRegistrations",
                                "kind": "LinkedHandle",
                                "name": "timeRegistrations"
                              }
                            ]
                          },
                          (v97/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v30/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v31/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v102/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_tasks",
                "kind": "LinkedHandle",
                "name": "tasks"
              },
              {
                "alias": null,
                "args": (v25/*: any*/),
                "concreteType": "AllocationTypeConnection",
                "kind": "LinkedField",
                "name": "allocations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AllocationTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Allocation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v63/*: any*/),
                          (v64/*: any*/),
                          (v65/*: any*/),
                          (v66/*: any*/),
                          (v67/*: any*/),
                          (v68/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v81/*: any*/),
                              (v86/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectType",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": (v18/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isSoft",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "allocations(first:100000)"
              },
              {
                "alias": "expenseFinancialNumbers",
                "args": [
                  (v98/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "searchQuery",
                    "value": {
                      "filters": [
                        {
                          "field": "ROLE",
                          "operator": "IS",
                          "value": "Um9sZTotMQ=="
                        }
                      ]
                    }
                  }
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  (v104/*: any*/)
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true,searchQuery:{\"filters\":[{\"field\":\"ROLE\",\"operator\":\"IS\",\"value\":\"Um9sZTotMQ==\"}]})"
              },
              {
                "alias": "totalFinancialNumbers",
                "args": [
                  (v98/*: any*/)
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  (v103/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "registeredMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nonBillableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  (v89/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allocationMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scopeApprovedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "remainingMinutes",
                    "storageKey": null
                  },
                  (v99/*: any*/),
                  (v51/*: any*/),
                  (v53/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedBillableMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedNonBillableMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedTotalMinutes",
                    "storageKey": null
                  },
                  (v52/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedMargin",
                    "storageKey": null
                  },
                  (v101/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "remainingCost",
                    "storageKey": null
                  },
                  (v54/*: any*/),
                  (v87/*: any*/),
                  (v100/*: any*/)
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true)"
              },
              {
                "condition": "fetchLazyData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v112/*: any*/),
                    "concreteType": "TimeRegTypeConnection",
                    "kind": "LinkedField",
                    "name": "timeRegistrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeRegType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v107/*: any*/),
                              (v108/*: any*/),
                              (v110/*: any*/),
                              (v109/*: any*/),
                              (v43/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v111/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": (v18/*: any*/),
                                "storageKey": null
                              },
                              (v38/*: any*/),
                              (v29/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v30/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v31/*: any*/)
                    ],
                    "storageKey": "timeRegistrations(first:10000000,onlyProjectRegistrations:true)"
                  },
                  {
                    "alias": null,
                    "args": (v112/*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "Project_timeRegistrations",
                    "kind": "LinkedHandle",
                    "name": "timeRegistrations"
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "companyProjectId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectServiceProjectType",
            "kind": "LinkedField",
            "name": "psProject",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgramType",
                "kind": "LinkedField",
                "name": "psProgram",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v20/*: any*/),
                  (v35/*: any*/),
                  (v59/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isViewerProgramMember",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ProjectScopingPageRefetchQuery",
    "operationKind": "query",
    "text": "query ProjectScopingPageRefetchQuery(\n  $projectId: String\n  $noStaleTasks: Boolean\n  $fetchLazyData: Boolean!\n  $fetchCustomFields: Boolean!\n  $personId: ID!\n) {\n  viewer {\n    component(name: \"new_scoping_refetch\")\n    ...ProjectScopingPage_viewer_1hnnKn\n    id\n  }\n}\n\nfragment LabelDropdownJS_labels on Label {\n  color\n  name\n  id\n  category {\n    id\n    name\n  }\n}\n\nfragment ProjectHeader_project on ProjectType {\n  id\n  companyProjectId\n  ...ProjectIndicatorJS_project\n  name\n  projectColor\n  isInProjectGroup\n  projectGroupCompanyId\n  projectGroupName\n  projectGroupColor\n  useBaseline\n  budgetType\n  sprintTimeBox\n}\n\nfragment ProjectHeader_psProject on ProjectServiceProjectType {\n  name\n  psProgram {\n    id\n    name\n    color\n    prefix\n    isViewerProgramMember\n  }\n}\n\nfragment ProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment ProjectScopingPage_viewer_1hnnKn on Viewer {\n  id\n  language\n  email\n  firstName\n  lastName\n  timerStartDate\n  actualPersonId\n  harvestUser\n  unit4User\n  excludeFromCompanyLockedPeriod\n  submitLockedDateYear\n  submitLockedDateMonth\n  submitLockedDateDay\n  startDate\n  endDate\n  createdAt\n  monday\n  tuesday\n  wednesday\n  thursday\n  friday\n  saturday\n  sunday\n  availableFeatureFlags {\n    key\n    id\n  }\n  timerTask {\n    id\n  }\n  company {\n    ...genericTaskContextMenu_company\n    jiraCloudEnabled\n    jiraServerEnabled\n    integrations {\n      jiraCloud {\n        syncSettings {\n          isJiraToForecastOneWaySync\n        }\n        id\n      }\n      jiraServer {\n        syncSettings {\n          isJiraToForecastOneWaySync\n        }\n        id\n      }\n      id\n    }\n    modules {\n      moduleType\n      id\n    }\n    person(id: $personId) {\n      id\n      role {\n        id\n        name\n      }\n    }\n    isUsingProjectAllocation\n    isUsingMixedAllocation\n    holidayCalendars(first: 10000) {\n      edges {\n        node {\n          id\n          holidayCalendarEntries(first: 100000) {\n            edges {\n              node {\n                id\n                name\n                year\n                month\n                day\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    allPersons(first: 1000000, onlyActive: true) {\n      edges {\n        node {\n          id\n          firstName\n          lastName\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n    currency\n    harvestEnabled\n    unit4Enabled\n    lockedPeriodYear\n    lockedPeriodMonth\n    lockedPeriodDay\n    labels(first: 1000000, labelType: TASK) {\n      edges {\n        node {\n          id\n          name\n          color\n          category {\n            id\n            name\n          }\n          ...LabelDropdownJS_labels\n        }\n      }\n    }\n    roles(first: 1000000) {\n      edges {\n        ...RoleDropdown_roles\n        node {\n          id\n          name\n        }\n      }\n    }\n    teams(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          teamPersons(first: 1000) {\n            edges {\n              node {\n                id\n                person {\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    customFieldDefinitionsV2(first: 1000) @include(if: $fetchCustomFields) {\n      edges {\n        node {\n          id\n          key\n          displayName\n          entityType\n          ... on TextCustomField {\n            readOnly\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  filters(first: 1000000, projectId: $projectId, filterSection: SCOPING) {\n    edges {\n      node {\n        id\n        name\n        section\n        value\n        updatedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  projects(first: 1000000, excludeRestricted: true) {\n    edges {\n      node {\n        id\n        companyProjectId\n        customProjectId\n        name\n        status\n        isInProjectGroup\n        projectColor\n      }\n    }\n  }\n  project(id: $projectId) {\n    ...ProjectHeader_project\n    ...SecondaryNavigation_project\n    projectFirstDateYear\n    projectFirstDateMonth\n    projectFirstDateDay\n    projectLastDateYear\n    projectLastDateMonth\n    projectLastDateDay\n    baselineTargetPrice\n    baselineTargetMinutes\n    id\n    isNoStaleTasksAllowed\n    name\n    demo\n    budgetWork\n    budgetType\n    defaultPeriodBudgetType\n    budget\n    billable\n    synchBaselineAndScopingDates\n    program {\n      name\n      prefix\n      budgetType\n      members {\n        edges {\n          node {\n            role\n            person {\n              id\n            }\n            id\n          }\n        }\n      }\n      id\n    }\n    sprintTimeBox\n    isInProjectGroup\n    useBaseline\n    projectGroupId\n    status\n    companyProjectId\n    customProjectId\n    estimationUnit\n    minutesPerEstimationPoint\n    timeRegistrations(first: 10000000, onlyProjectRegistrations: true) @include(if: $fetchLazyData) {\n      edges {\n        node {\n          id\n          minutesRegistered\n          billableMinutesRegistered\n          invoiced\n          price\n          updatedAt\n          year\n          month\n          day\n          retainerConflictHandled\n          task {\n            id\n          }\n          person {\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    retainerPeriods(first: 100000) {\n      edges {\n        node {\n          id\n          name\n          startYear\n          startMonth\n          startDay\n          endYear\n          endMonth\n          endDay\n          available\n          periodLength\n          periodPeriodicity\n          periodPriceAmount\n          periodHoursAmount\n          periodBudgetType\n          periodSettingIgnoreForBilling\n          periodSettingSubtractValue\n          periodSettingRollValue\n          periodSettingAddExpenses\n          periodDifferencePriceAmount\n          periodDifferenceHoursAmount\n          sharedPeriodDifferenceHoursAmount\n          sharedPeriodDifferencePriceAmount\n          ignoredRolloverHours\n          ignoredRolloverPrice\n          periodLocked\n          periodLockedTime\n        }\n      }\n    }\n    projectColor\n    projectStartYear\n    projectStartMonth\n    projectStartDay\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    useManualAllocations\n    remainingAutoCalculated\n    isJiraProject\n    useTaskOwner\n    useTaskFollowers\n    taskLevels\n    useTaskHierarchy\n    vstsProject\n    vstsAccount\n    harvestProjectId\n    vstsTwoWaySync\n    jiraSubtaskType\n    progress\n    manualProgressOnProjectEnabled\n    manualProgressOnPhasesEnabled\n    manualProgressOnTasksEnabled\n    financialSourceSettings {\n      plannedHours\n      plannedRevenue\n      plannedCost\n      actualRevenue\n      actualCost\n      forecastRevenue\n      id\n    }\n    jiraCloudProject {\n      id\n    }\n    jiraCloudEpicIds\n    jiraServerProject {\n      id\n    }\n    sageProject {\n      sageProjectId\n      id\n    }\n    statusColumnsV2(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          order\n          jiraStatusId\n          category\n        }\n      }\n    }\n    rateCard {\n      id\n      currency\n      rates(first: 10000) {\n        edges {\n          node {\n            id\n            rate\n            defaultRate\n            startDate\n            role {\n              id\n            }\n          }\n        }\n      }\n      disabledRoles {\n        id\n      }\n    }\n    projectPersons(first: 1000000) {\n      edges {\n        node {\n          id\n          role {\n            id\n            name\n          }\n          person {\n            id\n            firstName\n            lastName\n            fullName\n            initials\n            profilePictureId\n            profilePictureDefaultId\n            active\n            monday\n            tuesday\n            wednesday\n            thursday\n            friday\n            saturday\n            sunday\n            holidayCalendar {\n              id\n            }\n            role {\n              id\n              name\n            }\n            client {\n              id\n            }\n            allocations(first: 1000000, idleTimeOnly: true) {\n              edges {\n                node {\n                  id\n                  monday\n                  tuesday\n                  wednesday\n                  thursday\n                  friday\n                  saturday\n                  sunday\n                  startYear\n                  startMonth\n                  startDay\n                  endYear\n                  endMonth\n                  endDay\n                  idleTime {\n                    isInternalTime\n                    id\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    phases(first: 1000000) {\n      edges {\n        node {\n          baselineTargetPrice\n          baselineTargetMinutes\n          baselineCost\n          inheritDatesFrom\n          progress\n          progressDetails {\n            progress\n            id\n          }\n          phaseBaselineRoles {\n            edges {\n              node {\n                role {\n                  id\n                }\n                baselineMinutes\n                baselinePrice\n                id\n              }\n            }\n          }\n          id\n          name\n          startYear\n          startMonth\n          startDay\n          startFrom\n          deadlineDay\n          deadlineMonth\n          deadlineYear\n          deadlineFrom\n          baselineStartYear\n          baselineStartMonth\n          baselineStartDay\n          baselineDeadlineDay\n          baselineDeadlineMonth\n          baselineDeadlineYear\n          unit4Id\n          jiraId\n          phasePersons(first: 10000) {\n            edges {\n              node {\n                id\n                availableMinutes\n                scheduledMinutes\n                person {\n                  id\n                }\n              }\n            }\n          }\n          customFields @include(if: $fetchCustomFields) {\n            edges {\n              node {\n                __typename\n                key\n                displayName\n                value\n                type\n                ... on TextCustomFieldValue {\n                  readOnly\n                }\n                ... on DropdownCustomFieldValue {\n                  options {\n                    id\n                    displayName\n                  }\n                }\n                id\n              }\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    baselineFinancialNumbers: groupedFinancialNumbers(convertToProjectCurrency: true, groupBy: [\"PHASE_BASELINE_ROLE\", \"PHASE\"]) {\n      baselineRevenue\n      baselineTimeAndExpenses\n      baselineCost\n      baselineProfit\n      baselineMargin\n      baselineRatePerHour\n      baselineCostPerHour\n      baselineMinutes\n      phaseBaselineRoleId\n      phaseBaselineExpenseId\n      phaseId\n    }\n    sprints(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          endYear\n          endMonth\n          endDay\n          startYear\n          startMonth\n          startDay\n        }\n      }\n    }\n    tasks(first: 100000, simpleResponse: true, noStaleTasks: $noStaleTasks) {\n      edges {\n        node {\n          id\n          readOnly {\n            isReadOnly\n            id\n          }\n          userCanDeleteTask\n          userCantDeleteTaskReason\n          hasInvoicedTime\n          hasLockedTime\n          hasTimeRegistrations\n          approved\n          name\n          description\n          sortOrder\n          done\n          billable\n          blocked\n          progress @include(if: $fetchLazyData)\n  currentPrice @include(if: $fetchLazyData)\n  actualCost @include(if: $fetchLazyData)\n  plannedCost @include(if: $fetchLazyData)\n  timeLeft @include(if: $fetchLazyData)\n  timeRegistrations(first: 10000) @include(if: $fetchLazyData) {\n            edges {\n              node {\n                id\n                minutesRegistered\n                billableMinutesRegistered\n                price\n                invoiced\n                year\n                month\n                day\n                retainerConflictHandled\n                person {\n                  id\n                  role {\n                    id\n                  }\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          bug\n          latestUiUpdateAt\n          startFrom\n          deadlineFrom\n          startYear\n          startMonth\n          startDay\n          deadlineDay\n          deadlineMonth\n          deadlineYear\n          estimateForecast\n          estimateForecastMinutes\n          estimateForecastPrice\n          totalPriceAtCompletion\n          totalCostAtCompletion\n          allTotalTimeAndExpensesAtCompletion\n          companyTaskId\n          canStart\n          canBeSetToDone\n          highPriority\n          hasDependency\n          jiraId\n          vstsId\n          isUnit4Task\n          subTaskCount\n          parentTaskId\n          hasChildren\n          sageIntacctId\n          favoured\n          progressDetails {\n            progress\n            id\n          }\n          owner {\n            id\n            permissions\n          }\n          followers {\n            id\n            permissions\n          }\n          phase {\n            id\n            name\n            startYear\n            startMonth\n            startDay\n            startFrom\n            deadlineDay\n            deadlineMonth\n            deadlineYear\n            deadlineFrom\n          }\n          role {\n            id\n            name\n          }\n          sprint {\n            id\n            name\n            startYear\n            startMonth\n            startDay\n            endYear\n            endMonth\n            endDay\n          }\n          statusColumnV2 {\n            id\n            name\n            category\n          }\n          project {\n            id\n            demo\n            billable\n            estimationUnit\n            minutesPerEstimationPoint\n            projectStartYear\n            projectStartMonth\n            projectStartDay\n            projectEndYear\n            projectEndMonth\n            projectEndDay\n            budgetType\n            projectPerson(personId: $personId) {\n              role {\n                id\n                name\n              }\n              id\n            }\n            program {\n              name\n              prefix\n              budgetType\n              members {\n                edges {\n                  node {\n                    role\n                    person {\n                      id\n                    }\n                    id\n                  }\n                }\n              }\n              id\n            }\n            name\n            status\n            isJiraProject\n            vstsProject\n            vstsAccount\n            vstsTwoWaySync\n            projectColor\n            companyProjectId\n            customProjectId\n            harvestProject {\n              id\n            }\n            unit4Project {\n              id\n              activitiesEnabled\n            }\n            sprintTimeBox\n          }\n          taskLabels {\n            id\n            label {\n              id\n              name\n              color\n            }\n          }\n          taskDismissedNotifications {\n            taskOverrunPredictionDismissed\n            id\n          }\n          assignedPersons {\n            id\n            firstName\n            lastName\n            fullName\n            active\n            email\n            profilePictureId\n            profilePictureDefaultId\n            permissions\n          }\n          thisTaskDependsOn(first: 1000) {\n            edges {\n              node {\n                id\n                type\n                thisDependsOnTask {\n                  id\n                  name\n                  deadlineYear\n                  deadlineMonth\n                  deadlineDay\n                  startYear\n                  startMonth\n                  startDay\n                }\n              }\n            }\n          }\n          customFields @include(if: $fetchCustomFields) {\n            edges {\n              node {\n                __typename\n                key\n                displayName\n                value\n                type\n                ... on TextCustomFieldValue {\n                  readOnly\n                }\n                ... on DropdownCustomFieldValue {\n                  options {\n                    id\n                    displayName\n                  }\n                }\n                id\n              }\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    allocations(first: 100000) {\n      edges {\n        node {\n          id\n          monday\n          tuesday\n          wednesday\n          thursday\n          friday\n          saturday\n          sunday\n          startYear\n          startMonth\n          startDay\n          endYear\n          endMonth\n          endDay\n          person {\n            id\n            role {\n              id\n            }\n            holidayCalendar {\n              id\n            }\n          }\n          project {\n            id\n          }\n          isSoft\n        }\n      }\n    }\n    expenseFinancialNumbers: financialNumbers(searchQuery: {filters: [{field: ROLE, operator: IS, value: \"Um9sZTotMQ==\"}]}, convertToProjectCurrency: true) {\n      allTotalTimeAndExpensesAtCompletion\n    }\n    totalFinancialNumbers: financialNumbers(convertToProjectCurrency: true) {\n      totalCostAtCompletion\n      totalRevenueRecognition\n      totalRevenueProfitAtCompletion\n      totalRevenueMarginAtCompletion\n      forecastMinutes\n      registeredMinutes\n      billableActualMinutes\n      nonBillableActualMinutes\n      billableTotalTimeAndExpensesAtCompletion\n      baselineMinutes\n      allocationMinutes\n      scopeApprovedMinutes\n      remainingMinutes\n      baselineRevenue\n      plannedCost\n      actualCost\n      projectedBillableMinutes\n      projectedNonBillableMinutes\n      projectedTotalMinutes\n      plannedRevenue\n      plannedProfit\n      plannedMargin\n      baselineMargin\n      remainingCost\n      actualRevenue\n      baselineCost\n      baselineProfit\n    }\n  }\n  psProject(companyProjectId: $projectId) {\n    ...ProjectHeader_psProject\n    id\n  }\n}\n\nfragment RoleDropdown_roles on RoleTypeEdge {\n  node {\n    name\n    id\n  }\n}\n\nfragment SecondaryNavigation_project on ProjectType {\n  companyProjectId\n  customProjectId\n  sprintTimeBox\n  budgetType\n  projectGroupId\n  useBaseline\n  hasInvoices\n  financialSourceSettings {\n    plannedCost\n    plannedRevenue\n    actualCost\n    actualRevenue\n    forecastCost\n    forecastRevenue\n    id\n  }\n}\n\nfragment genericTaskContextMenu_company on Company {\n  id\n  jiraCloudEnabled\n  jiraServerEnabled\n  integrations {\n    jiraCloud {\n      syncSettings {\n        isJiraToForecastOneWaySync\n      }\n      id\n    }\n    jiraServer {\n      syncSettings {\n        isJiraToForecastOneWaySync\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e217eca1ca43d81d3d1c0ce33d47da64';
export default node;
